//License PROPRIETARY

import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import {createStore,applyMiddleware ,combineReducers} from 'redux';
// import {logger} from 'redux-logger';
import thunkMiddleware from 'redux-thunk';

import {setUser, projectInfo,languagesFilter, summariesState, historyData, recomputeReminderState, viewModeState, jiraIssueState, locationsState} from './state/reducers/app'
import {elementExclusion,licenseFix, copyrightLicense, multiLicenseExclusionProgress} from './state/reducers/exclusions'
import {modalState} from "./state/reducers/modals"
import './style/index.css';
import './style/alternate-footer.css';

import App from './containers/App';
import * as serviceWorker from './serviceWorker';

const rootReducer=combineReducers({
	setUser, projectInfo,elementExclusion, multiLicenseExclusionProgress, licenseFix,languagesFilter, summariesState, historyData, recomputeReminderState, copyrightLicense, viewModeState,
    modalState, jiraIssueState, locationsState
})
const store=createStore(rootReducer,applyMiddleware(thunkMiddleware))//, logger)); 


ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider> , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
